import { useEffect } from "react";
import "@/App.css";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import SocialProofStrip from "@/components/SocialProofStrip";
import Method from "@/components/Method";
import Services from "@/components/Services";
import CaseStudies from "@/components/CaseStudies";
import Pricing from "@/components/Pricing";
import Footer from "@/components/Footer";
import FloatingWhatsApp from "@/components/FloatingWhatsApp";

function App() {
  useEffect(() => {
    document.title =
      "Rimfluences — Social Media Agency per attività locali e brand";
  }, []);

  return (
    <div className="App" data-testid="app-root">
      <Header />
      <main>
        <Hero />
        <SocialProofStrip />
        <Method />
        <Services />
        <CaseStudies />
        <Pricing />
      </main>
      <Footer />
      <FloatingWhatsApp />
    </div>
  );
}

export default App;
